import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Spinner from './Spinner';

const Accordion = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContet] = useState(props.content ?? null);

  async function toggle() {
    if (content) {
      setIsOpen(!isOpen);
    }

    if (!content && props.fetchContent) {
      setIsOpen(true);
      const newContent = await props.fetchContent();
      setContet(newContent);
    }
  }

  return (
    <div
      className={`accordion-react ${isOpen ? 'accordion-react--opened' : ''} ${
        props.className
      } ${!props.content && !props.fetchContent ? 'accordion--empty' : ''}`}
    >
      <div className="accordion">
        <div className="accordion__title" onClick={toggle}>
          {props.title}
        </div>
        {isOpen && (
          <>
            {!content ? (
              <Spinner />
            ) : (
              <div className="accordion__content">{content}</div>
            )}
          </>
        )}
      </div>
      <div
        onClick={toggle}
        className={`accordion__symbol ${isOpen ? 'accordion--open' : ''}`}
      ></div>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.object,
  content: PropTypes.object,
  fetchContent: PropTypes.func,
  className: PropTypes.string,
};

export default Accordion;
